module.exports = __webpack_public_path__ + "img/乳液.765845fa.jpg";